<div class="padding">
	<b>Upload multiple shots</b>

	<div class="flex margin-top-small">
		<div class="flex-1 flex column margin-right">
			<div class="bg-orange margin-bottom-small padding-small">
				<i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>

				Please rename your files following the
				<span class="hover primary" (click)="openEstimatedNameModal()">pattern</span>
			</div>

			<div class="flex between center margin-bottom-small">
				<div class="flex center">File list:</div>

				<div class="flex center">
					<div class="flex hover center primary margin-right" (click)="copyFilenamesToClipboard()">
						Copy all
						<i class="fa-solid fa-copy margin-left-smallest"></i>
					</div>
					<div class="flex hover center primary" (click)="downloadFilenamesExcel()">
						Export to XLS
						<i class="fa-solid fa-file-export margin-left-smallest"></i>
					</div>
				</div>
			</div>
			<div class="fix-height scrollable">
				@for (i of data.estimatedCodes; track i) {
					<div class="border-grey flex center padding-smallest">
						<span class="unicode black margin-right-small">{{ i }}</span>
						<i class="grey small fa fa-copy hover" (click)="copyCodeToClipboard(i)"></i>
					</div>
				}
			</div>
		</div>
		<div class="flex-1">
			<div class=" bg-light-grey  justify-center center flex column fix-height {{ isDragging ? 'bg-lightest-blue' : '' }}" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
				@if (!isDragging) {
					@if (uploading) {
						@if (uploadProgress == 100) {
							<div class="flex center column">
								<i class="fa fa-spinner primary fa-2xl fa-spin margin-bottom"></i>
								<div class="flex center">Processing files...</div>
							</div>
						} @else {
							<div class="flex center column">
								<h4 class="primary">{{ uploadProgress }}%</h4>
								Uploading...
							</div>

							<div class="progress-bar margin-top-smallest">
								<div class="progress bg-primary" [style.width.%]="uploadProgress"></div>
							</div>
						}
					} @else {
						<div class="flex column center grey margin-bottom">
							<span>Allowed formats: .ZIP</span>
							<span>Max file size: {{ environment.maxFileSize }}MB</span>
						</div>

						<input type="file" #fileInput (change)="onFilesSelected($event)" style="display: none" />

						<button (click)="fileInput.click()">
							<i class="fa-solid fa-upload margin-right-smallest"></i>
							Upload .ZIP file
						</button>
					}
				} @else {
					<div class="flex column center primary">
						<i class="fa-solid fa-upload fa-2x margin-bottom-smallest"></i>
						<span>Drop your files here...</span>
					</div>
				}
			</div>
		</div>
	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button (click)="close()" class="stroked">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
